var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContainer',[_c('NotFound',{attrs:{"text":"Die aufgerufene Seite kann leider nicht gefunden werden."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }